import { render, staticRenderFns } from "./Box4.vue?vue&type=template&id=2e3d60f7&scoped=true&"
import script from "./Box4.vue?vue&type=script&lang=js&"
export * from "./Box4.vue?vue&type=script&lang=js&"
import style0 from "./Box4.vue?vue&type=style&index=0&id=2e3d60f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d60f7",
  null
  
)

export default component.exports